import React, { forwardRef } from 'react';
import { useIntl } from 'react-intl';
import { CloseIcon } from '@panwds/icons';
import { redScale } from '@panwds/tailwindcss';
import { animated } from '@react-spring/web';
import { classNames } from '../../utils/classNames/classNames.esm.js';
import 'tslib';
import '@popperjs/core';
import '../Icon/ImgIcon.esm.js';
import '../Icon/FaIcon.esm.js';
import { InfoIcon, WarningIcon, DangerIcon, SuccessIcon } from '../Icon/SemanticIcons.esm.js';
import { Body } from '../Typography/Body.esm.js';
import '../Tooltip/Tooltip.esm.js';

var icons = {
    clear: null,
    info: React.createElement(InfoIcon, { addClassName: "tw-text-dark-bg-blue" }),
    warning: React.createElement(WarningIcon, null),
    error: React.createElement(DangerIcon, { style: { color: redScale[400] } }),
    success: React.createElement(SuccessIcon, null)
};
var Toast = forwardRef(function (_a, ref) {
    var appearance = _a.appearance, remove = _a.remove, life = _a.life, text = _a.text;
    var intl = useIntl();
    var message = Array.isArray(text) ? text : [text];
    return (React.createElement("div", { className: "tw-pt-4 tw-pr-4", ref: ref },
        React.createElement("div", { "data-testid": "toast", role: "alert", className: classNames("tw-w-80 tw-p-4 tw-relative tw-overflow-hidden", "tw-bg-blue-steel-900 tw-text-dark-bg dark:tw-bg-blue-steel-1000", "tw-flex tw-items-center tw-gap-4 tw-rounded tw-shadow-lg") },
            icons[appearance] && React.createElement("div", null, icons[appearance]),
            React.createElement("div", { className: "tw-flex-grow tw-space-y-1 tw-min-w-0" }, message.map(function (paragraph) { return (React.createElement(Body, { key: paragraph, size: "sm", addClassName: "tw-text-dark-bg tw-break-words" }, paragraph)); })),
            React.createElement("button", { "aria-label": intl.formatMessage({ id: "atoMCu", defaultMessage: [{ type: 0, value: "Close" }] }), className: "tw-text-white tw-border-none tw-bg-transparent hover:tw-text-disabled tw-p-0", onClick: remove, type: "button" },
                React.createElement(CloseIcon, { size: "xs", className: "tw-mt-1" })),
            React.createElement(animated.div, { className: "tw-absolute tw-bottom-0 tw-left-0 tw-h-1 tw-bg-gradient-to-r tw-from-blue-700 tw-to-blue-300", "data-testid": "toast-progress", style: { width: life } }))));
});
Toast.displayName = "Toast";

export { Toast };
//# sourceMappingURL=Toast.esm.js.map
